import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { GoalSummary, useGoalsSummary } from '../../useGoalsSummary';
import { GoalsListLoading } from './GoalsList.loading';
import { GridWrapper } from '../GridWrapper/GridWrapper';
import { ErrorState } from '../ErrorState/ErrorState';
import { isPdfArea } from '../../../../CommonSelectors/CommonAreaSelector';
import { GoalCard } from '../GoalCard/GoalCard';
import { GoalTypeDTO } from '../../../types/goalsDTO';
import { DecumulationCard } from '../../../Goals/goals/Decumulation/components/DecumulationCard/DecumulationCard';

interface GoalsListProps {
  clientId: string;
}

export const GoalsList = ({ clientId }: GoalsListProps) => {
  const { data, isLoading, refetch, error, isError } = useGoalsSummary();

  const isPDF = useSelector(isPdfArea);

  if (isLoading) {
    return <GoalsListLoading />;
  }

  if (isError) {
    return <ErrorState clientId={clientId} error={error} refetch={refetch} />;
  }

  if (!data) {
    return null;
  }

  return (
    <GridWrapper isFullWidth={data.length === 1} mb={isPDF ? '0' : '32'}>
      {data.map(goal => (
        <Box as="li" key={goal.GoalId}>
          <GoalsListContent goal={goal} />
        </Box>
      ))}
    </GridWrapper>
  );
};

interface ContentProps {
  goal: GoalSummary;
}

export const GoalsListContent = ({ goal }: ContentProps) => {
  if (goal.GoalType === GoalTypeDTO.Decumulation) {
    return <DecumulationCard goal={goal} />;
  }

  return <GoalCard goal={goal} />;
};
